<template>
  <main class="apple-tesla-container">
    <section class="hero-section text-center">
      <b-container class="mt-4 pt-4">
        <b-row align-h="center" class="justify-content-center">
          <b-col lg="8" md="10">
            <span class="badge-subtle">Soluții B2B Corporate</span>
            <h1 class="hero-title">Ești manager, C.E.O. sau deții o firmă?</h1>
            <p class="hero-subtitle">
              Completează formularul de mai jos, iar echipa noastră te va contacta pentru a configura planul perfect adaptat companiei tale.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <section class="form-section">
      <b-container class="d-flex justify-content-center">
        <b-row align-h="center" class="justify-content-center w-100">
          <b-col lg="6" md="8" sm="12" class="mx-auto">
            <div class="glass-card">
              <form @submit.prevent="registerMesaj">

                <div class="form-row-double">
                  <div class="custom-form-group">
                    <label class="input-label">Nume *</label>
                    <b-form-input
                        placeholder="Popescu"
                        type="text"
                        v-model="registerData.first_name"
                        class="custom-input"
                    ></b-form-input>
                  </div>

                  <div class="custom-form-group">
                    <label class="input-label">Prenume *</label>
                    <b-form-input
                        placeholder="Andrei"
                        type="text"
                        v-model="registerData.last_name"
                        class="custom-input"
                    ></b-form-input>
                  </div>
                </div>

                <div class="custom-form-group">
                  <label class="input-label">Adresă E-Mail *</label>
                  <b-form-input
                      placeholder="nume@companie.ro"
                      type="email"
                      v-model="registerData.email"
                      class="custom-input"
                  ></b-form-input>
                </div>

                <div class="custom-form-group">
                  <label class="input-label">Telefon *</label>
                  <b-form-input
                      placeholder="+40 7xx xxx xxx"
                      type="tel"
                      v-model="registerData.phone"
                      class="custom-input"
                  ></b-form-input>
                </div>

                <div class="custom-form-group">
                  <label class="input-label">Oraș *</label>
                  <b-form-input
                      placeholder="București"
                      type="text"
                      v-model="registerData.city"
                      class="custom-input"
                  ></b-form-input>
                </div>

                <div class="custom-form-group">
                  <label class="input-label">Mesaj *</label>
                  <b-form-textarea
                      placeholder="Descrie pe scurt cerințele companiei tale..."
                      rows="4"
                      max-rows="6"
                      v-model="registerData.mesaj"
                      class="custom-input custom-textarea"
                  ></b-form-textarea>
                </div>

                <div class="action-container">
                  <b-button type="submit" class="btn-apple-primary" :disabled="isBusy">
                    {{ isBusy ? 'Se trimite...' : 'Trimite Solicitarea' }}
                  </b-button>
                </div>

              </form>

              <!-- Informare legală & GDPR -->
              <div class="privacy-notice">
                <p>
                  Prin trimiterea acestui formular pe <strong>coressy.com</strong>, ești de acord cu stocarea și prelucrarea datelor tale personale conform
                  <a href="/protectia-datelor" class="legal-link">Politicii de Confidențialitate</a> și
                  <a href="/termeni-si-conditii" class="legal-link">Termenilor și Condițiilor</a> noastre.
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import Auth from '@/components/auth'

export default {
  name: "InregistrareCompanie",
  data() {
    return {
      isBusy: false,
      registerData: {
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
        city: '',
        mesaj: '',
        type_entry: 'Companie',
      }
    };
  },
  methods: {
    async registerMesaj() {
      this.isBusy = true;
      try {
        let registerResponse = await Auth.formContact(this.registerData)
        if (registerResponse.success) {
          this.registerData = {
            email: "",
            first_name: "",
            last_name: "",
            phone: "",
            city: "",
            mesaj: "",
            type_entry: 'Companie'
          };
          this.$toastr.s('Mulțumim! Te vom contacta în cel mai scurt timp.');
        } else {
          this.$toastr.e('Vă rugăm să completați toate câmpurile obligatorii.');
        }
      } catch (e) {
        this.$toastr.e('A apărut o eroare. Încearcă din nou.');
      } finally {
        this.isBusy = false;
      }
    },
  }
};
</script>

<style scoped>
/* Apple Light Theme Styles */
.apple-tesla-container {
  padding-top: 60px;
  padding-bottom: 80px;
  background-color: #f5f5f7;
  color: #1d1d1f;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Forțează centrarea pe containerul secțiunii */
.form-section {
  display: flex;
  justify-content: center;
  width: 100%;
}

/* Badge subtil */
.badge-subtle {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
  font-weight: 600;
  color: #86868b;
  margin-bottom: 12px;
}

/* Hero Section */
.hero-title {
  font-size: 2.75rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: #1d1d1f;
  margin-bottom: 16px;
  line-height: 1.1;
}

.hero-subtitle {
  font-size: 1.125rem;
  line-height: 1.47;
  color: #515154;
  max-width: 600px;
  margin: 0 auto 40px auto;
  font-weight: 400;
}

/* Card Alb Minimalist */
.glass-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  margin: 0 auto; /* Centrare explicită */
}

/* Form Layout */
.form-row-double {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 576px) {
  .form-row-double {
    grid-template-columns: 1fr;
  }
}

.custom-form-group {
  margin-bottom: 20px;
}

.input-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: #6e6e73;
  margin-bottom: 8px;
}

/* Inputuri stil Apple */
.custom-input {
  width: 100%;
  background-color: #f2f2f7 !important;
  border: 1px solid #e5e5ea !important;
  border-radius: 12px !important;
  color: #1d1d1f !important;
  padding: 12px 16px !important;
  font-size: 0.95rem !important;
  transition: all 0.2s ease !important;
}

.custom-input::placeholder {
  color: #86868b;
}

.custom-input:focus {
  background-color: #ffffff !important;
  border-color: #0071e3 !important;
  box-shadow: 0 0 0 4px rgba(0, 113, 227, 0.15) !important;
  outline: none !important;
}

.custom-textarea {
  resize: vertical;
}

/* Buton stil Apple */
.action-container {
  margin-top: 28px;
}

.btn-apple-primary {
  width: 100%;
  background-color: #0071e3 !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 1rem !important;
  padding: 14px 24px !important;
  border-radius: 12px !important;
  transition: all 0.2s ease !important;
  cursor: pointer;
}

.btn-apple-primary:hover {
  background-color: #0077ed !important;
  box-shadow: 0 4px 12px rgba(0, 113, 227, 0.25);
}

.btn-apple-primary:active {
  transform: scale(0.99);
}

/* Subsol legal */
.privacy-notice {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #e5e5ea;
  font-size: 0.78rem;
  color: #86868b;
  line-height: 1.5;
  text-align: center;
}

.legal-link {
  color: #515154;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.legal-link:hover {
  color: #0071e3;
}
</style>
